
export function getPrintLayerXyz(layer) {

    let printLayer = {}
    printLayer.baseURL = layer.Url
    printLayer.type = 'XYZ'
    printLayer.presentationID = layer.PresentationID
    printLayer.domainID = layer.DomainID
    printLayer.sorting = layer.zIndex
    printLayer.opacity = layer.Opacity / 10

    return printLayer
}
